import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { BadgeOutlined, GroupOutlined, LockOutlined, MailOutline, PersonOutline, PhoneInTalkOutlined, VerifiedUserOutlined, VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { NotifyModal } from "layouts/NotifyModal";
import { useAppDispatch } from "../../../redux/store/configureStore";
import { getProfile, clearGetProfile } from "../../../redux/handlers/profile/getProfile.handler";
import { updateProfile, clearUpdateProfile } from "../../../redux/handlers/profile/updateProfile.handler";
import { changeProfilePassword, clearChangeProfilePassword } from "../../../redux/handlers/profile/changeProfilePassword.handler";
import { getInfoAdminSystem } from "utils/HelperFunction";
import "./profile.css";
var PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
var PROFILE_PLACEHOLDER = {
    username: "",
    nickname: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    role: ""
};
var getErrorMessage = function(error) {
    var _error_response_data, _error_response;
    var message = ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || error.message;
    return Array.isArray(message) ? message.map(String) : [
        typeof message === "string" ? message : "เกิดข้อผิดพลาดหรือเครือข่ายขัดข้อง"
    ];
};
var escapeHtml = function(value) {
    return String(value).replace(/[&<>"']/g, function(character) {
        return ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        })[character];
    });
};
var PasswordInput = function(param) {
    var controlId = param.controlId, label = param.label, name = param.name, placeholder = param.placeholder, value = param.value, visible = param.visible, onChange = param.onChange, onToggle = param.onToggle, isInvalid = param.isInvalid, feedback = param.feedback;
    return /*#__PURE__*/ _jsxs(Form.Group, {
        controlId: controlId,
        children: [
            /*#__PURE__*/ _jsx(Form.Label, {
                className: "mb-2",
                children: label
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "profile-password-field",
                children: [
                    /*#__PURE__*/ _jsx(Form.Control, {
                        required: true,
                        type: visible ? "text" : "password",
                        name: name,
                        value: value,
                        placeholder: placeholder,
                        isInvalid: isInvalid,
                        onChange: onChange,
                        autoComplete: name === "currentPassword" ? "current-password" : "new-password"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "",
                        className: "profile-password-toggle",
                        onClick: onToggle,
                        "aria-label": visible ? "ซ่อน".concat(label) : "แสดง".concat(label),
                        children: visible ? /*#__PURE__*/ _jsx(VisibilityOffOutlined, {}) : /*#__PURE__*/ _jsx(VisibilityOutlined, {})
                    }),
                    /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                        type: "invalid",
                        children: feedback
                    })
                ]
            })
        ]
    });
};
export function Profile() {
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(PROFILE_PLACEHOLDER), 2), profileData = _useState[0], setProfileData = _useState[1];
    var _useState1 = _sliced_to_array(useState(PROFILE_PLACEHOLDER), 2), draftProfile = _useState1[0], setDraftProfile = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isEditingProfile = _useState2[0], setIsEditingProfile = _useState2[1];
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var userId = adminInfo.userId;
    var _useState3 = _sliced_to_array(useState(true), 2), isLoadingProfile = _useState3[0], setIsLoadingProfile = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isSaving = _useState4[0], setIsSaving = _useState4[1];
    var savingRef = useRef(false);
    var _useState5 = _sliced_to_array(useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    }), 2), passwords = _useState5[0], setPasswords = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false
    }), 2), passwordVisibility = _useState6[0], setPasswordVisibility = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), submitted = _useState7[0], setSubmitted = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        show: false,
        message: ""
    }), 2), successModal = _useState8[0], setSuccessModal = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        show: false,
        messages: []
    }), 2), errorModal = _useState9[0], setErrorModal = _useState9[1];
    useEffect(function() {
        var controller = new AbortController();
        var loadProfile = function() {
            var _ref = _async_to_generator(function() {
                var _data_sysRole, response, data, _data_sys_user_nname, _data_sys_user_fname, _data_sys_user_lname, _data_sys_user_phone, _data_sysRole_sys_role_name, profile, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoadingProfile(true);
                            setProfileData(PROFILE_PLACEHOLDER);
                            setIsEditingProfile(false);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            if (!userId || !accessToken) throw new Error("ไม่พบข้อมูลผู้ใช้งาน กรุณาเข้าสู่ระบบใหม่");
                            return [
                                4,
                                dispatch(getProfile(userId, {
                                    signal: controller.signal
                                }))
                            ];
                        case 2:
                            response = _state.sent();
                            data = response === null || response === void 0 ? void 0 : response.data;
                            if (!(data === null || data === void 0 ? void 0 : data.sys_user_username)) throw new Error("ไม่พบข้อมูลโปรไฟล์ผู้ใช้งาน");
                            if (controller.signal.aborted) return [
                                2
                            ];
                            profile = {
                                username: data.sys_user_username,
                                nickname: (_data_sys_user_nname = data.sys_user_nname) !== null && _data_sys_user_nname !== void 0 ? _data_sys_user_nname : "",
                                firstName: (_data_sys_user_fname = data.sys_user_fname) !== null && _data_sys_user_fname !== void 0 ? _data_sys_user_fname : "",
                                lastName: (_data_sys_user_lname = data.sys_user_lname) !== null && _data_sys_user_lname !== void 0 ? _data_sys_user_lname : "",
                                phone: (_data_sys_user_phone = data.sys_user_phone) !== null && _data_sys_user_phone !== void 0 ? _data_sys_user_phone : "",
                                email: data.sys_user_username,
                                role: (_data_sysRole_sys_role_name = (_data_sysRole = data.sysRole) === null || _data_sysRole === void 0 ? void 0 : _data_sysRole.sys_role_name) !== null && _data_sysRole_sys_role_name !== void 0 ? _data_sysRole_sys_role_name : ""
                            };
                            setProfileData(profile);
                            setDraftProfile(profile);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            if (!controller.signal.aborted) {
                                setErrorModal({
                                    show: true,
                                    messages: getErrorMessage(error)
                                });
                            }
                            return [
                                3,
                                5
                            ];
                        case 4:
                            if (!controller.signal.aborted) setIsLoadingProfile(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadProfile() {
                return _ref.apply(this, arguments);
            };
        }();
        loadProfile();
        return function() {
            controller.abort();
            dispatch(clearGetProfile());
            dispatch(clearUpdateProfile());
            dispatch(clearChangeProfilePassword());
        };
    }, [
        userId,
        accessToken,
        dispatch
    ]);
    var actionsDisabled = isLoadingProfile || isSaving || !userId || !profileData.username;
    var profileItems = [
        {
            key: "nickname",
            label: "ชื่อเล่น",
            value: profileData.nickname,
            icon: PersonOutline,
            editable: true
        },
        {
            key: "firstName",
            label: "ชื่อ",
            value: profileData.firstName,
            icon: BadgeOutlined,
            editable: true
        },
        {
            key: "lastName",
            label: "นามสกุล",
            value: profileData.lastName,
            icon: GroupOutlined,
            editable: true
        },
        {
            key: "phone",
            label: "เบอร์โทร",
            value: profileData.phone,
            icon: PhoneInTalkOutlined
        },
        {
            key: "email",
            label: "อีเมล",
            value: profileData.email,
            icon: MailOutline
        },
        {
            key: "role",
            label: "สิทธิ์การใช้งาน",
            value: profileData.role,
            icon: VerifiedUserOutlined
        }
    ];
    var newPasswordInvalid = submitted && !PASSWORD_PATTERN.test(passwords.newPassword);
    var confirmPasswordInvalid = submitted && (!passwords.confirmPassword || passwords.confirmPassword !== passwords.newPassword);
    var handlePasswordChange = function(event) {
        var _event_target = event.target, name = _event_target.name, value = _event_target.value;
        setPasswords(function(currentValue) {
            return _object_spread_props(_object_spread({}, currentValue), _define_property({}, name, value));
        });
    };
    var handleEditProfile = function() {
        setDraftProfile(profileData);
        setIsEditingProfile(true);
    };
    var handleDraftProfileChange = function(event) {
        var _event_target = event.target, name = _event_target.name, value = _event_target.value;
        setDraftProfile(function(currentValue) {
            return _object_spread_props(_object_spread({}, currentValue), _define_property({}, name, value));
        });
    };
    var showSuccessModal = function(message) {
        setSuccessModal({
            show: true,
            message: message
        });
    };
    var showErrorModal = function(messages) {
        setErrorModal({
            show: true,
            messages: Array.isArray(messages) ? messages : [
                messages
            ]
        });
    };
    var handleSaveProfile = function() {
        var _ref = _async_to_generator(function() {
            var missingFields, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionsDisabled || savingRef.current) return [
                            2
                        ];
                        missingFields = [
                            !draftProfile.nickname.trim() && "ชื่อเล่น",
                            !draftProfile.firstName.trim() && "ชื่อ",
                            !draftProfile.lastName.trim() && "นามสกุล"
                        ].filter(Boolean);
                        if (missingFields.length > 0) {
                            showErrorModal(missingFields.map(function(fieldName) {
                                return "กรุณากรอก".concat(fieldName);
                            }));
                            return [
                                2
                            ];
                        }
                        savingRef.current = true;
                        setIsSaving(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            dispatch(updateProfile({
                                sys_user_id: userId,
                                sys_user_username: profileData.username,
                                sys_user_fname: draftProfile.firstName.trim(),
                                sys_user_lname: draftProfile.lastName.trim(),
                                sys_user_nname: draftProfile.nickname.trim()
                            }))
                        ];
                    case 2:
                        _state.sent();
                        setProfileData(function(currentValue) {
                            return _object_spread_props(_object_spread({}, currentValue), {
                                nickname: draftProfile.nickname.trim(),
                                firstName: draftProfile.firstName.trim(),
                                lastName: draftProfile.lastName.trim()
                            });
                        });
                        setIsEditingProfile(false);
                        showSuccessModal("บันทึกข้อมูลโปรไฟล์สำเร็จ");
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        showErrorModal(getErrorMessage(error));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        savingRef.current = false;
                        setIsSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSaveProfile() {
            return _ref.apply(this, arguments);
        };
    }();
    var togglePasswordVisibility = function(name) {
        setPasswordVisibility(function(currentValue) {
            return _object_spread_props(_object_spread({}, currentValue), _define_property({}, name, !currentValue[name]));
        });
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator(function(event) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        if (actionsDisabled || savingRef.current) return [
                            2
                        ];
                        setSubmitted(true);
                        if (!passwords.currentPassword) {
                            showErrorModal("กรุณากรอกรหัสผ่านปัจจุบัน");
                            return [
                                2
                            ];
                        }
                        if (!PASSWORD_PATTERN.test(passwords.newPassword)) {
                            showErrorModal("รหัสผ่านใหม่ไม่ตรงตามเงื่อนไขที่กำหนด");
                            return [
                                2
                            ];
                        }
                        if (!passwords.confirmPassword || passwords.confirmPassword !== passwords.newPassword) {
                            showErrorModal("ยืนยันรหัสผ่านใหม่ไม่ตรงกัน");
                            return [
                                2
                            ];
                        }
                        savingRef.current = true;
                        setIsSaving(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            dispatch(changeProfilePassword({
                                sys_user_id: userId,
                                sys_user_username: profileData.username,
                                password: passwords.newPassword,
                                confirm_password: passwords.confirmPassword
                            }))
                        ];
                    case 2:
                        _state.sent();
                        setPasswords({
                            currentPassword: "",
                            newPassword: "",
                            confirmPassword: ""
                        });
                        setSubmitted(false);
                        setPasswordVisibility({
                            currentPassword: false,
                            newPassword: false,
                            confirmPassword: false
                        });
                        showSuccessModal("เปลี่ยนรหัสผ่านสำเร็จ");
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        showErrorModal(getErrorMessage(error));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        savingRef.current = false;
                        setIsSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs("div", {
        className: "profile-page pb-4",
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-3",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item tc-7",
                            children: "โปรไฟล์"
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1",
                            "aria-current": "page",
                            children: "ข้อมูลโปรไฟล์"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "fs-24 mb-3",
                children: "ข้อมูลโปรไฟล์"
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-2 profile-card mb-4",
                children: /*#__PURE__*/ _jsxs(Card.Body, {
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-20 mb-3",
                            children: "ข้อมูลโปรไฟล์"
                        }),
                        isLoadingProfile && /*#__PURE__*/ _jsx("div", {
                            role: "status",
                            className: "text-muted mb-3",
                            children: "กำลังโหลดข้อมูลโปรไฟล์..."
                        }),
                        /*#__PURE__*/ _jsx(Row, {
                            className: "g-0 profile-info-grid",
                            children: profileItems.map(function(item) {
                                var Icon = item.icon;
                                return /*#__PURE__*/ _jsxs(Col, {
                                    xs: 12,
                                    md: 6,
                                    xl: 4,
                                    className: "profile-info-item",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "profile-info-icon",
                                            children: /*#__PURE__*/ _jsx(Icon, {})
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "profile-info-content",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "profile-info-label",
                                                    children: item.label
                                                }),
                                                isEditingProfile && item.editable ? /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    disabled: isSaving,
                                                    name: item.key,
                                                    value: draftProfile[item.key],
                                                    placeholder: "กรอก".concat(item.label),
                                                    "aria-label": item.label,
                                                    className: "profile-info-edit-control",
                                                    onChange: handleDraftProfileChange
                                                }) : /*#__PURE__*/ _jsx("div", {
                                                    className: "profile-info-value",
                                                    title: item.value || "-",
                                                    children: item.value || "-"
                                                })
                                            ]
                                        }),
                                        item.key === "role" && /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            disabled: actionsDisabled,
                                            variant: "",
                                            className: "profile-edit-button".concat(isEditingProfile ? " profile-save-button" : ""),
                                            onClick: isEditingProfile ? handleSaveProfile : handleEditProfile,
                                            children: isEditingProfile ? "บันทึก" : "แก้ไข"
                                        })
                                    ]
                                }, item.label);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-2 profile-card",
                children: /*#__PURE__*/ _jsxs(Card.Body, {
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-20 mb-4",
                            children: "แก้ไขรหัสผ่าน"
                        }),
                        /*#__PURE__*/ _jsx(Form, {
                            noValidate: true,
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: actionsDisabled,
                                children: [
                                    /*#__PURE__*/ _jsxs(Row, {
                                        className: "g-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: 4,
                                                children: /*#__PURE__*/ _jsx(PasswordInput, {
                                                    controlId: "profile-current-password",
                                                    label: "รหัสผ่านปัจจุบัน",
                                                    name: "currentPassword",
                                                    placeholder: "กรอกรหัสผ่านปัจจุบัน",
                                                    value: passwords.currentPassword,
                                                    visible: passwordVisibility.currentPassword,
                                                    onChange: handlePasswordChange,
                                                    onToggle: function() {
                                                        return togglePasswordVisibility("currentPassword");
                                                    },
                                                    isInvalid: submitted && !passwords.currentPassword,
                                                    feedback: "กรุณากรอกรหัสผ่านปัจจุบัน"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: 4,
                                                children: /*#__PURE__*/ _jsx(PasswordInput, {
                                                    controlId: "profile-new-password",
                                                    label: "รหัสผ่านใหม่",
                                                    name: "newPassword",
                                                    placeholder: "กรอกรหัสผ่านใหม่",
                                                    value: passwords.newPassword,
                                                    visible: passwordVisibility.newPassword,
                                                    onChange: handlePasswordChange,
                                                    onToggle: function() {
                                                        return togglePasswordVisibility("newPassword");
                                                    },
                                                    isInvalid: newPasswordInvalid,
                                                    feedback: "รหัสผ่านใหม่ไม่ตรงตามเงื่อนไขที่กำหนด"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: 4,
                                                children: /*#__PURE__*/ _jsx(PasswordInput, {
                                                    controlId: "profile-confirm-password",
                                                    label: "ยืนยันรหัสผ่านใหม่",
                                                    name: "confirmPassword",
                                                    placeholder: "ยืนยันรหัสผ่านใหม่",
                                                    value: passwords.confirmPassword,
                                                    visible: passwordVisibility.confirmPassword,
                                                    onChange: handlePasswordChange,
                                                    onToggle: function() {
                                                        return togglePasswordVisibility("confirmPassword");
                                                    },
                                                    isInvalid: confirmPasswordInvalid,
                                                    feedback: "ยืนยันรหัสผ่านใหม่ไม่ตรงกัน"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Row, {
                                        className: "align-items-center g-3 mt-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: true,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "profile-password-note",
                                                    children: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข และอักขระพิเศษ"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                sm: "auto",
                                                children: /*#__PURE__*/ _jsxs(Button, {
                                                    type: "submit",
                                                    variant: "",
                                                    className: "btn-st-7 profile-password-submit w-100",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(LockOutlined, {
                                                            className: "me-2",
                                                            fontSize: "small"
                                                        }),
                                                        "เปลี่ยนรหัสผ่าน"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: successModal.show,
                textsuccess: successModal.message,
                onHide: function() {
                    return setSuccessModal(function(currentValue) {
                        return _object_spread_props(_object_spread({}, currentValue), {
                            show: false
                        });
                    });
                }
            }),
            /*#__PURE__*/ _jsx(NotifyModal, {
                show: errorModal.show,
                onHide: function() {
                    return setErrorModal(function(currentValue) {
                        return _object_spread_props(_object_spread({}, currentValue), {
                            show: false
                        });
                    });
                },
                hTitle: "แจ้งเตือน",
                msgText: errorModal.messages.map(escapeHtml).join("<br><br>"),
                heightM: Math.min(320, 80 + errorModal.messages.length * 60)
            })
        ]
    });
}
